import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { postDeliveryLocationDistrictV2 } from '../../../../actions';
import { DELIVERY_LOCATION_DISTRICT_PATH } from '../../../../config/paths';
import NewDeliveryLocationDistrictForm from './NewDeliveryLocationDistrictForm';

const NewDeliveryLocationDistrict = ({
  breadcrumbs,
  dispatchPostDeliveryLocationDistrictV2,
}) => {
  const onSubmit = (formValues) => {
    const items = formValues.deliveryDistrict || [];

    if (!Array.isArray(items) || items.length === 0) {
      toastr.error('Error', 'Debes agregar al menos una ubicación.');
      return;
    }

    const locIds = items
      .map((i) => i.location.value)
      .filter((id) => id != null);

    const counts = locIds.reduce((acc, id) => {
      acc[id] = (acc[id] || 0) + 1;
      return acc;
    }, {});

    const dupIds = Object.keys(counts).filter((id) => counts[id] > 1);

    if (dupIds.length > 0) {
      const dupNames = dupIds
        .map((sid) => {
          const id = Number(sid);
          const item = items.find((i) => i.location.value === id);
          return item.location.label || `ID=${id}`;
        })
        .join(', ');
      toastr.error(
        'Error',
        `Ubicaciones duplicadas: ${dupNames}. Elimina los duplicados para continuar.`,
      );
      return;
    }

    const payload = items.map(({ location, districtPostalCodeIds }) => ({
      locationId: location.value,
      districtPostalCodeIds: (districtPostalCodeIds || []).map((d) => d.value),
    }));

    dispatchPostDeliveryLocationDistrictV2(payload);
  };

  const content = <NewDeliveryLocationDistrictForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Ubicación con Sectores Distritos Autorizados para Reparto"
      subtitle="Nueva ubicación con sectores distritos autorizados para reparto"
      content={content}
    />
  );
};

NewDeliveryLocationDistrict.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDeliveryLocationDistrictV2: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostDeliveryLocationDistrictV2: postDeliveryLocationDistrictV2,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Ubicaciones con Sectores de Distritos Autorizados para Reparto',
      href: DELIVERY_LOCATION_DISTRICT_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewDeliveryLocationDistrict);
